import { ProductsEnums } from "enums/ProductsEnums";
import { generatePath } from "react-router-dom";
import { AppRoutes } from "routes/routeConstants/appRoutes";

export const navigateProductOverview = (
    productId?: number,
    stage?: number,
    status?: string,
    navigate?:(path:string, options?: { replace?: boolean } )=>void,
    replace?: boolean
  ) => {

    let path = ""

    switch (stage) {
      case 0:
        path = generatePath(
          `/${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL}`,
          { id: productId }
        )
        break
      case 1:
        path = generatePath(
          `/${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL_TRANSPORTATION}`,
          { id: productId }
        )
        break
      case 2:
        path = generatePath(
          `/${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_PROCESSING_FACILITY}`,
          { id: productId }
        )
        break
      case 3:
        path = generatePath(
          `/${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_PRODUCT_DISTRIBUTION}`,
          { id: productId }
        )
        break

      case 4:
        path = generatePath(AppRoutes.PRODUCT_OVERVIEW, { id: productId })
    }

    if (status && status !== ProductsEnums.DRAFT) {
      path = generatePath(AppRoutes.PRODUCT_OVERVIEW, { id: productId })
    }

    navigate?.(path,{replace})

  };